import "./NoItemsMissingModal.scss";

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import GradientButton from "../../../../components/buttons/gradientButton/GradientButton";
import OutlinedPinkButton from "../../../../components/buttons/outlinedPinkButton/OutlinedPinkButton";
import { addItemToCart, removeItemFromCart } from "../../../../redux/cart/reducer";
import { MinusIcon, PlusIcon } from "../../../../components/Icon";
import {
  BeersArray,
  CocktailsArray,
  FoodArray,
  HotDrinksArray,
  OtherArray,
  SoftsArray,
  WineArray,
  CategoriesArray,
} from "../../../../utility/data";
import { Icons } from "../../../../images/icons";

function NoItemsMissingModal({
  open,
  setOpen,
  setCartModal,
  total,
  setTotal,
  items,
  setCareModalOpen,
}) {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const cartStore = useSelector(
    (state) => state.cartReducer.cartByOrg[orgId] || []
  );
  const { t } = useTranslation("takeaway");

  function handleRedirection() {
    if (total < 5) {
      setOpen(false);
      setCareModalOpen(true);
    } 
    else {
      setOpen(false);
      setCartModal(true);
    }
  }

  return (
    <>
      <Modal
        onHide={setOpen}
        show={open}
        centered
        className="no-items-missing-modal"
      >
        <Modal.Body>
          <h2 className="title">{t('title')}</h2>
          <div className="scrollable-list">
            {items.map((item, index) => (
              <ProductItem
                cart={cartStore}
                add={(item) => {
                  setTotal((prev) => prev + parseFloat(item.price));
                  dispatch(addItemToCart({ orgId, item }));
                }}
                remove={(item) => {
                  if (
                    cartStore.find((prd) => prd.id === item.id)?.quantity > 0
                  ) {
                    setTotal((prev) => prev - parseFloat(item.price));
                    dispatch(removeItemFromCart({ orgId, item }));
                  }
                }}
                key={item.id}
                item={item}
              />
            ))}
          </div>
          <div className="total--price">
            <span>{t("total")}</span>
            <span style={{ color: "#27AE60" }}>€{total.toFixed(2)}</span>
          </div>
          <div className="buttons-container">
            <GradientButton onPress={handleRedirection}>{t('cart')}</GradientButton>
            <OutlinedPinkButton onPressFunction={() => setOpen(false)}>
              {t("cancel")}
            </OutlinedPinkButton>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const ProductItem = ({ item, cart, add, remove }) => {
  const prdIndex = cart.find((prd) => prd.id === item.id);

  const iconArrays = {
    Food: { array: FoodArray, default: Icons.food },
    Softs: { array: SoftsArray, default: Icons.soft },
    Beers: { array: BeersArray, default: Icons.beer },
    Cocktails: { array: CocktailsArray, default: Icons.cocktail },
    Wine: { array: WineArray, default: Icons.wine },
    "Hot drinks": { array: HotDrinksArray, default: Icons.drink },
    Other: { array: OtherArray, default: Icons.others },
    default: { array: CategoriesArray, default: Icons.others },
  };

  const getImageSrc = (item) => {
    const category = item?.category;
    const iconData = iconArrays[category] || iconArrays.default;

    if (item?.customIcon && item.customIcon !== "") {
      return (
        iconData.array.find((i) => i.name === item.customIcon)?.icon ||
        iconData.default
      );
    } 
    else {
      return iconData.default;
    }
  };

  return (
    <div className="takeaway-item">
      <div className="img-content-group">
        <div className="img">
          <img src={getImageSrc(item)} alt="item" />
        </div>
        <div className="content">
          <p className="subtext">{item.subtitle}</p>
          <h3 className="subtitle">{item.title}</h3>
          <div className="price">
            <span className="quantity">
              x {prdIndex ? prdIndex.quantity : "0"}
            </span>
            <span style={{ color: "#27AE60" }}>
              {(item.price * 1).toFixed(2)}€
            </span>
          </div>
        </div>
      </div>
      <div className="button-group">
        <button onClick={() => add(item)}>
          <PlusIcon />
        </button>
        <div className="divider"></div>
        <button type="button" onClick={() => remove(item)}>
          <MinusIcon />
        </button>
      </div>
    </div>
  );
};

export default NoItemsMissingModal;
